const COLORS = {
  beverages: '#2979BD',
  clearance: '#36C07E',
};

export default COLORS;
